import { Component, Input, ViewEncapsulation } from '@angular/core';
import { WidgetModel } from '@fi-app/widget/model/widget.model';
import { fiWidgetGetTextId } from '@fi-shared/widget/widget-registry';

@Component({
    selector: 'fi-appearance-available-widgets-list',
    templateUrl: './available-widgets-list.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./available-widgets-list.component.scss'],
    standalone: false,
})
export class FiAppearanceAvailableWidgetsListComponent {
    @Input() availableWidgets: WidgetModel[];

    getWidgetTextId(widget: WidgetModel) {
        return fiWidgetGetTextId(widget.WidgetType);
    }
}
